import { useFormContext } from "react-hook-form";

import CField from "$forms/CField";
import useAuth from "$hooks/useAuth";
import useOrder from "$hooks/useOrder";
import PostalCode from "$forms/PostalCode";
import AddressSelect from "$forms/AddressSelect";
import { CompanyType } from "$types/CompanyType";

type Props = {
  country: string;
  companyTypes: CompanyType[];
};

export default function AddressDetails({ country, companyTypes }: Props) {
  const { isAdmin } = useAuth();
  const { classes: sclasses } = useOrder();
  const {
    control,
    formState: { errors },
    setValue,
  } = useFormContext();

  const isOnlySupplier =
    companyTypes.length === 1 && companyTypes[0] === CompanyType.SUPPLIER;

  const addressChange = (data: string) => {
    if (Array.isArray(data)) {
      let street = "";

      data.forEach((elem: any) => {
        if (elem.types.includes("postal_code")) {
          setValue("postalCode", elem.long_name);
        }
        if (elem.types.includes("country")) {
          setValue("country", elem.long_name);
        }
        if (elem.types.includes("locality")) {
          setValue("city", elem.long_name);
        }
        if (elem.types.includes("street_number")) {
          if (street === "") {
            street += elem.long_name;
          } else {
            street = `${elem.long_name}${street}`;
          }
        }
        if (elem.types.includes("route")) {
          street += ` ${elem.long_name}`;
        }
      });
      setValue("adress", street);
    } else {
      setValue("adress", data);
    }
  };

  return (
    <>
      <div className={sclasses.newFormFieldsRow}>
        <CField
          control={control}
          label="Adresse"
          disabled={!isAdmin()}
          name="adress"
          required={!isOnlySupplier}
          error={errors.adress}
          rules={{
            required: !isOnlySupplier ? "Veuillez remplir ce champ" : false,
          }}
        >
          {(props: any) => (
            <AddressSelect
              value={props.value}
              required={!isOnlySupplier}
              onChange={addressChange}
            />
          )}
        </CField>
      </div>
      <div className={sclasses.newFormFieldsRow}>
        <CField
          label="Complément d'adresse"
          disabled={!isAdmin()}
          control={control}
          name="complementAdress"
          error={errors.complementAdress}
        />
      </div>
      <div className={sclasses.newFormFieldsRow}>
        <div className={sclasses.newFormFieldSmallCol}>
          <PostalCode
            disabled={!isAdmin()}
            control={control}
            name="postalCode"
            error={errors.postalCode}
            country={country}
            required={!isOnlySupplier}
          />
        </div>
        <div className={sclasses.newFormFieldsCol}>
          <CField
            label="Ville"
            disabled={!isAdmin()}
            control={control}
            name="city"
            required={!isOnlySupplier}
            error={errors.city}
            rules={{
              required: !isOnlySupplier ? "Veuillez remplir ce champ" : false,
            }}
          />
        </div>
        <div className={sclasses.newFormFieldSmallCol}>
          <CField
            label="Pays"
            disabled={!isAdmin()}
            control={control}
            name="country"
            required={!isOnlySupplier}
            error={errors.country}
            rules={{
              required: !isOnlySupplier ? "Veuillez remplir ce champ" : false,
            }}
          />
        </div>
      </div>
    </>
  );
}
